import { FormEvent, useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { auth } from "../api/client";
import { useAuth } from "../auth/AuthContext";
import BBrand from "../components/b/BBrand";
import BBtn from "../components/b/BBtn";

const REMEMBERED_EMAIL_KEY = "rcpt_remembered_email";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [remember, setRemember] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [submitting, setSubmitting] = useState(false);
  const [canRegister, setCanRegister] = useState(false);

  useEffect(() => {
    const saved = localStorage.getItem(REMEMBERED_EMAIL_KEY);
    if (saved) {
      setEmail(saved);
      setRemember(true);
    }
    auth
      .config()
      .then((c) => {
        setCanRegister(c.allow_registration);
        // Fresh install: send the first visitor straight to account creation.
        if (c.first_user) navigate("/register", { replace: true });
      })
      .catch(() => setCanRegister(false));
  }, [navigate]);

  async function handleSubmit(e: FormEvent) {
    e.preventDefault();
    setError(null);
    setSubmitting(true);
    try {
      if (remember) localStorage.setItem(REMEMBERED_EMAIL_KEY, email);
      else localStorage.removeItem(REMEMBERED_EMAIL_KEY);
      await login(email, password);
      navigate("/app/dashboard", { replace: true });
    } catch (err) {
      setError(err instanceof Error ? err.message : "Login failed");
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <div className="auth-card-wrap">
      <div className="brand-auth">
        <BBrand to="/" />
      </div>
      <div className="auth-card">
        <h1>Sign in</h1>
        <p className="auth-sub">Sign in to your Set &amp; Ledger workspace.</p>

        {error && <div className="auth-error">{error}</div>}

        <form onSubmit={handleSubmit} className="auth-form">
          <label>
            Email
            <input type="email" required autoFocus={!email} value={email} onChange={(e) => setEmail(e.target.value)} />
          </label>
          <label>
            Password
            <input
              type="password"
              required
              autoFocus={!!email}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </label>
          <label style={{ display: "flex", alignItems: "center", flexDirection: "row", gap: 8, fontWeight: 400 }}>
            <input
              type="checkbox"
              checked={remember}
              onChange={(e) => setRemember(e.target.checked)}
              style={{ width: "auto", margin: 0 }}
            />
            Remember my email on this device
          </label>
          <BBtn type="submit" full disabled={submitting} style={{ marginTop: 8 }}>
            {submitting ? "Signing in…" : "Sign in"}
          </BBtn>
        </form>

        {canRegister && (
          <p className="auth-foot">
            New here? <Link to="/register">Create an account</Link>
          </p>
        )}
      </div>
    </div>
  );
}
